import { NewsItem } from "../molecules/NewsCard";
import NewsCard from "../molecules/NewsCard";

type Props = {
  items: NewsItem[];
};

const NewsGrid = ({ items }: Props) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      {items.map((i) => (
        <NewsCard key={i.id} item={i} />
      ))}
    </div>
  );
};

export default NewsGrid;
